import { type TitreProps } from "./Titre.interface";

type HeadingTag = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

const Titre = ({ children, niveauDeTitre, styleDeTitre }: TitreProps) => {
  const Balise: HeadingTag = niveauDeTitre;

  if (!children || children === "") return null;

  return <Balise className={styleDeTitre ? `fr-${styleDeTitre}` : ""}>{children}</Balise>;
};

export default Titre;
